<template>
  <div id="UserCenter">
    <!-- 用户中心 -->
    <div class="banner">
      <!-- <el-image class="background" :src="require('@/assets/imgs/banner2.jpeg')" fit='cover'></el-image> -->
      <el-image class="background" :src="banner" fit='cover'></el-image>
      <!-- <b class="mask"></b>
      <div class="main">
        <img class="ban" src="../../assets/imgs/banner.png" alt="">
        <div class="cont">
          <p>参与案例征集</p>
          <b>项目周期：2024年3月-2025年4月</b>
          <b>指导发起单位：中国初级卫生保健基金会</b>
          <b>执行单位：北京生命绿洲公益服务中心</b>
          <b>鸣谢支持：<img :src="require('@/assets/imgs/QL_logo2.png')" alt=""></b>
        </div>
      </div> -->
      <!-- <img class="frame" src="../../assets/imgs/Frame.png" alt=""> -->
    </div>
    <div class="user" v-if="userInfo">
      <el-avatar :src="require('../../assets/imgs/userbase.png')" icon="el-icon-user-solid"></el-avatar>
      <el-divider direction="vertical"></el-divider>
<!--      <div class="tougao">-->
<!--        <p>{{ Statistics && Statistics.AllNum ? Statistics.AllNum : '0' }}</p>-->
<!--        <b>案例数</b>-->
<!--      </div>-->
<!--      <el-divider direction="vertical"></el-divider>-->
<!--      <div class="tongguo">-->
<!--        <p>{{ Statistics && Statistics.SuccessNum ? Statistics.SuccessNum : '0' }}</p>-->
<!--        <b>协议签署数</b>-->
<!--      </div>-->
      <el-divider direction="vertical"></el-divider>
      <div class="opts">
        <!--        <el-button @click="switchItems">切换项目</el-button>-->
        <el-button @click="logOut">退出登录</el-button>
      </div>
    </div>
    <div class="user" v-if="!userInfo">
      <el-avatar :src="require('../../assets/imgs/userbase2.png')" icon="el-icon-user-solid"></el-avatar>
<!--      <el-divider direction="vertical"></el-divider>-->
<!--      <div class="tougao">-->
<!--        <p>-</p>-->
<!--        <b>案例数</b>-->
<!--      </div>-->
<!--      <el-divider direction="vertical"></el-divider>-->
<!--      <div class="tongguo">-->
<!--        <p>-</p>-->
<!--        <b>入围数</b>-->
<!--      </div>-->
      <el-divider direction="vertical"></el-divider>
      <div class="opts">
        <el-button @click="loginDialogFun('登录')">登录</el-button>
        <el-button @click="loginDialogFun('注册')">注册</el-button>
      </div>
    </div>
    <div class="part3">
      <div class="tit">
        <p>参与案例征集</p>
      </div>

      <div class="cont">
        <dl @click="registerDialogCk()">
          <dt>
            <img src="../../assets/imgs/grzc.svg" alt="">
          </dt>
          <dd v-if="userInfo.fullName">1.修改资料</dd>
          <dd v-else>完善资料</dd>
        </dl>
        <dl @click="contributeDialogCk()">
          <dt>
            <img src="../../assets/imgs/wzsc.svg" alt="">
          </dt>
          <dd>2.填写案例</dd>
        </dl>
<!--        <dl @click="download(`/article/template/downloadTemplate`)">-->
<!--          <dt>-->
<!--            <img src="../../assets/imgs/mbxz.svg" alt="">-->
<!--          </dt>-->
<!--          <dd>资料下载</dd>-->
<!--        </dl>-->
<!--    -->
        <dl @click="signContract">
          <dt>
            <img src="../../assets/imgs/hetong.png" alt="">
          </dt>
          <dd>3.签署劳务</dd>
        </dl>
      </div>
    </div>
    <div class="part2">
      <div class="tit">
        <p>案例记录</p>
        <b>Case  Record</b>
      </div>

      <div class="cont">
        <div class="document">
          <el-table :data="tableData" style="width: 100%">

            <el-table-column fixed min-width="200">
              <template slot="header" slot-scope="scope">
                案例名称
              </template>
              <template slot-scope="scope">
                {{ scope.row.inpName || '' }}
              </template>
            </el-table-column>

<!--            &lt;!&ndash;            动态生成的表单字段列表&ndash;&gt;-->
<!--            <template v-for="(field,index) in formConfig">-->
<!--              <el-table-column :prop="field.key" :label="field.label" :key="index">-->
<!--                <template slot-scope="scope">-->
<!--                  &lt;!&ndash; 处理不同字段类型的显示 &ndash;&gt;-->
<!--                  <template v-if="field.type === 'checkbox'">-->
<!--                    {{ formatCheckboxValue(scope.row[field.key], field) }}-->
<!--                  </template>-->

<!--                  <template v-else-if="field.type === 'radio'">-->
<!--                    {{ formatRadioValue(scope.row[field.key], field) }}-->
<!--                  </template>-->

<!--                  <template v-else>-->
<!--                    {{ scope.row[field.key] || '-' }}-->
<!--                  </template>-->
<!--                </template>-->
<!--              </el-table-column>-->
<!--            </template>-->

            <el-table-column prop="date" label="上传时间" sortable width="150">
              <template slot-scope="scope">
                {{ $moment(scope.row.inpEntDate).format('YYYY/MM/DD HH:mm') }}
              </template>
            </el-table-column>
            <el-table-column prop="date" label="审核时间" sortable width="150">
              <template slot-scope="scope">
                <template v-if="scope.row.auditTime">
                  {{ $moment(scope.row.auditTime).format('YYYY/MM/DD HH:mm') }}
                </template>
                <template v-else>未审核</template>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="120" fixed="right">
              <template slot-scope="scope">
                <span v-if="scope.row.auditStatus == 'DRAFT'">
									<i class="el-icon-info" style="color: #565867;">保存(待提交)</i>
								</span>
								<span v-else-if="scope.row.auditStatus == 'WAIT'">
									<i class="el-icon-info" style="color: #565867;">初审中</i>
								</span>
                <span v-else-if="scope.row.auditStatus == 'SUCCESS'">
									<i class="el-icon-success" style="color:green;">初审成功</i>
								</span>
                <span v-else-if="scope.row.auditStatus == 'ERROR'|| scope.row.auditStatus == 'REVIEW_ERROR'">
									<el-popover placement="top" title="" width="200" trigger="hover"
                              :content="scope.row.errorMessage" v-if="scope.row.errorMessage">
										<i slot="reference" class="el-icon-error" style="color:brown;">初审驳回</i>
									</el-popover>
									<i slot="reference" class="el-icon-error" style="color:brown;" v-else>初审驳回</i>
								</span>

              </template>
            </el-table-column>


<!--            <el-table-column v-if="projectInfo.projectSignSwitch=='ON'" label="签署状态" width="120"-->
<!--                             :key="Math.random().toString(36).substr(2, 9)" fixed="right">-->
<!--              <template slot-scope="scope">-->
<!--								<span v-if="scope.row.agreementStatus == 'WAIT'">-->
<!--									<i class="el-icon-info" style="color: #565867;">待签署</i>-->
<!--								</span>-->
<!--                <span v-if="scope.row.agreementStatus == 'FINISH'">-->
<!--									<i class="el-icon-info" style="color: green;">已签署</i>-->
<!--								</span>-->
<!--                <span v-else>-->
<!--								- -->
<!--								</span>-->
<!--              </template>-->
<!--            </el-table-column>-->


            <el-table-column label="操作" width="130" fixed="right" align="center" >
              <template slot-scope="scope">
<!--                <div style="display: flex;align-items: center">-->
                  <el-button type="text" class="look" @click="contributeDialogCk">查看</el-button>
<!--                  <el-button  v-loading="loadingsign"-->
<!--                              v-if="scope.row.auditStatus == 'SUCCESS'"-->
<!--                              type="text" class="look" @click="signContract">劳务签署-->
<!--                  </el-button>-->
<!--                </div>-->


              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize"
                       @current-change="handleCurrentChange" :current-page.sync="pageNum"
                       :hide-on-single-page="true"></el-pagination>
      </div>
    </div>

    <el-dialog :visible.sync="loginDialog" v-if="loginDialog" width="600px" :show-close="false"
               :destroy-on-close="true">
      <div class="top" v-if="logType=='登录'">
        <p>登录</p>
        <b>Login</b>
      </div>
      <div class="top" v-if="logType=='注册'">
        <p>注册</p>
        <b>register</b>
      </div>
      <div class="top" v-if="logType=='忘记密码'">
        <p>重置密码</p>
        <b>reset password</b>
      </div>
      <login @loginSuccess="loginSuccessFun($event)" @toRegister="toRegister($event)"></login>
    </el-dialog>

    <el-dialog :visible.sync="registerDialog" v-if="registerDialog" width="900px" :show-close="false">
      <div class="top">
        <p v-if="userInfo.fullName">修改资料</p>
        <p v-else>完善资料</p>
        <b>Improve information</b>
      </div>
      <register @editUserSuccess="registerSuccessFun($event)"></register>
    </el-dialog>

    <el-dialog top="10px" :visible.sync="contributeDialog" v-if="contributeDialog"  width="900px"    :close-on-click-modal="false" custom-class="contribute-dialog">
      <div class="dialog-body">
        <!-- 头部 -->
        <div class="top">
          <p>{{surveyInfo.surName}}</p>
<!--          <b>contribute</b>-->
        </div>

        <el-alert v-if="surveyInfo.auditStatus == 'ERROR'|| surveyInfo.auditStatus == 'REVIEW_ERROR'"
                  :title="surveyInfo.errorMessage"
            type="error">
        </el-alert>

        <!-- 可滚动内容区 -->
        <div class="dialog-content">
          <fm-generate-form class="my-custom-form"
              :data="jsonData" :print-read="!['DRAFT','ERROR',null].includes(this.surveyInfo.auditStatus)"
              :value="editData"
              ref="generateForm"
          />
        </div>


        <!-- 底部按钮 -->
        <div class="dialog-footer" v-if="['DRAFT','ERROR',null].includes(this.surveyInfo.auditStatus)">

<!--          &lt;!&ndash; [新增] 导入 Excel 按钮 &ndash;&gt;-->
<!--          <el-button style="float: left"-->
<!--              type="success"-->
<!--              icon="el-icon-upload2"-->
<!--              @click="triggerExcelImport"-->
<!--              :loading="importLoading"-->
<!--          >-->
<!--            {{ importLoading ? '解析中...' : '导入 Excel 自动填充' }}-->
<!--          </el-button>-->

          <!-- [新增] 导入功能下拉菜单 -->
          <el-dropdown style=" margin-right: 8px" trigger="click" @command="handleImportCommand">
            <el-button type="success" icon="el-icon-upload2">
              导入 Excel 数据 <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <!-- 选项 1: 下载模板 -->
              <el-dropdown-item command="downloadTemplate" icon="el-icon-download">
                下载标准模板
              </el-dropdown-item>

              <!-- 分割线 -->
              <el-divider style="margin: 0;"></el-divider>

              <!-- 选项 2: 上传文件 (触发原有的隐藏 input) -->
              <el-dropdown-item command="uploadFile" icon="el-icon-upload">
                {{ importLoading ? '解析中...' : '上传文件自动填充' }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <!-- 隐藏的文件输入框 -->
          <input
              type="file"
              ref="excelInput"
              style="display: none"
              accept=".xlsx, .xls"
              @change="handleFileChange"
          />




          <!-- 原有按钮组 (建议放在右侧，使用 flex 布局或 margin-left) -->
          <div style="margin-left: auto; display: inline-block;">
            <el-button type="primary" @click="handleSave()">保存</el-button>
            <el-button type="primary" @click="handleSubmit">提交</el-button>
          </div>
        </div>

        <div class="dialog-footer" v-if="['WAIT'].includes(this.surveyInfo.auditStatus)">
          <el-button type="primary" @click="reWrite">重新填写</el-button>
        </div>

      </div>

<!--      <el-form>-->
<!--      <el-form-item class="checked">-->
<!--        <el-checkbox ></el-checkbox>-->
<!--        <a >作品原创及授权声明</a>-->
<!--      </el-form-item>-->
<!--      </el-form>-->
    </el-dialog>

    <el-dialog class="docView" :visible.sync="docViewShow" v-if="docViewShow">
      <iframe v-if="docview.documentType == 'TEXT'" :src="docview.downloadPath"
              :title="docview.surName"></iframe>
      <!-- <video v-else :src="docview.downloadPath" controls intrinsicsize></video> -->
      <video-player v-else ref="videoPlayer" class="player-video" :playsinline="false" :options="playOptions"
                    @pause="onPlayerPause($event)" />
    </el-dialog>

    <el-dialog class="oldUser" :visible.sync="olduserShow" v-if="olduserShow" width="600px">
      <img src="../../assets/imgs/yanzheng.png" alt="">
      <div class="UserBody">
        <el-alert title="我们检测到系统中多个账户可能属于一个用户，请协助我们核实" type="error" effect="dark"></el-alert>
        <el-row>
          <el-col :span="24"><span class="">账号：</span> <b>{{ oldUser.userName }}</b></el-col>
          <el-col :span="24"><span class="">医院：</span> <b>{{ oldUser.hospital }}</b></el-col>
          <el-col :span="24"><span class="">科室：</span> <b>{{ oldUser.department }}</b></el-col>
          <el-col :span="24"><span class="">用户姓名：</span> <b>{{ oldUser.fullName }}</b></el-col>
          <el-col :span="24"><span class="">身份证号：</span> <b>{{ oldUser.cardId }}</b></el-col>
        </el-row>
      </div>
      <!-- {{oldUser}} -->
      <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="isMyAccount(false)  ">不属于我</el-button>
				<el-button type="success" @click="isMyAccount(true)">此账号属于我</el-button>
			</span>
    </el-dialog>
    <UploadMaterialDialog ref="UploadMaterialDialog"></UploadMaterialDialog>

    <el-dialog title="提示" :visible.sync="centerDialogVisible" width="50%" center>
      <div>尊敬的【{{ userInfo.fullName }}】</div>
      <div v-for="(item,index) in tipList" :key="index">
        <div class="reasonText" v-if="item.type=='user'">您的个人备案信息因【{{ item.reason }}】审核未通过，请及时修改，以免影响您正常的劳务结算流程。
        </div>
        <div class="reasonText" v-if="item.type=='document'">
          您于【{{ $moment(item.submitTime).format('YYYY/MM/DD HH:mm') }}】提交的作品【{{ item.surName }}】因【{{ item.reason }}】审核未通过，请您修改后重新上传。
        </div>
        <div class="reasonText" v-if="item.type=='case'">
          您于【{{ $moment(item.submitTime).format('YYYY/MM/DD HH:mm') }}】提交的案例,因【{{ item.reason }}】审核未通过，请您修改后重新提交。
        </div>
        <div class="reasonText" v-if="item.type=='sign'">
          您于【{{ $moment(item.submitTime).format('YYYY/MM/DD HH:mm') }}】提交的作品【{{ item.surName }}】审核通过，请及时完成劳务签署，以免影响您正常的劳务结算流程。
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
				<el-button type="primary" style="width: 100%" @click="confirmCenterDialogVisible">确 定</el-button>
			</span>
    </el-dialog>

  </div>
</template>

<script>
import register from '@/components/userCenter/register'

import UploadMaterialDialog from '@/components/UploadMaterialDialog.vue';
import login from '@/components/userCenter/login'
import contribute from '@/components/userCenter/contribute'
import baseUrl from "@/request/config.js"
import {
  coverUser,
  submitInpsurvey,
  getCase,
  signAgreement,
  getConfig,
  getProject,
  getTips,
  getUser,
  myDocument,
  myStatistics,
  ProjectPage,
  regist, withdrawInpsurvey, uploadCaseExcel ,
} from '@/request/api.js';

export default {
  name: 'UserCenter',
  components: {
    UploadMaterialDialog,
    register,
    login,
    contribute
  },
  data() {
    return {
      //导入状态控制
      importLoading:false,
      // [重要] 字段映射表 (如果后端 key 和前端 field 不一致，需在此配置)
      // 假设后端返回 { jzsj: "2026-03-03", zhusu: "头痛" }
      // 假设前端 form-create 的 field 定义为 { field_1: "visit_date", field_2: "complaint" }
      // 你需要建立这样的映射关系。如果 key 完全一致，可以留空或使用默认逻辑。
      fieldMap: {
        // '后端 key': '前端 field 名'
        // 'jzsj': 'field_visit_date',
        // 'zhusu': 'field_complaint',
        // ... 其他字段
      },
      surveyInfo:{},
      jsonData:{},
      editData:{},
      loadingsign: false,
      centerDialogVisible: false,
      oldUser: '',
      olduserShow: false,
      playOptions: {
        height: "100%",
        width: "100%",
        playbackRates: [1.0, 2.0, 3.0], // 可选的播放速度
        autoplay: true, // 如果为true,浏览器准备好时开始回放
        muted: false, // 默认情况下静音播放
        loop: false, // 是否视频一结束就重新开始
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据，auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值，值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小，换句话说，它将按比例缩放以适应其容器
        sources: [{
          // type: "video/mp4", // 类型
          // src: require("./1.mp4"), // url地址，在使用本地的资源时，需要用require()引入，否则控制台会报错
        }],
        poster: "", // 设置封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息
        controlBar: {
          currentTimeDisplay: true,
          progressControl: true, // 是否显示进度条
          playbackRateMenuButton: true, // 是否显示调整播放倍速按钮
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: true, // 是否显示剩余时间功能
          fullscreenToggle: true, // 是否显示全屏按钮
        },
      },
      banner: '',
      userInfo: '',
      tipList: [],
      Statistics: '', // 用户投稿信息
      baseUrl: '',
      docViewShow: false,
      docview: '',
      loginDialog: false,
      registerDialog: false,
      contributeDialog: false,
      pageSize: 10,
      total: 0,
      pageNum: 1,
      tableData: [],

      logType: '注册',

      registeData: '',
      projectInfo: {},
      formConfig: [
        // {key: 'documentName', label: '文档名称'},
        // {key: 'documentType', label: '类型', type: 'dict', dictKey: 'doc_type'},
        // {key: 'createTime', label: '上传时间', type: 'datetime'},
        // {key: 'changeTime', label: '审核时间', type: 'datetime'},
        // {key: 'documentStatus', label: '状态', type: 'status'},
      ],
      // 字典映射可选
      dict: {
        doc_type: {
          TEXT: '文档',
          VEDIO: '视频',
          MANGA: '漫画'
        }
      },
      mainColor: ''

    }
  },
  created() {
    this.mainColor = localStorage.getItem('mainColor');
    this.baseUrl = baseUrl;
    this.queryProject()

    const headToken = localStorage.getItem('headToken')
    if (headToken) {
      this.getUserFun();
      this.getMyStatistics();
      // this.getMyDocument();
      this.getTips()
      this.loadCase();
    }
    this.getConfigFun();
    this.getProjectFun();

  },
  mounted() {
    this.options();
  },
  watch: {
    "$store.state.logType": {
      handler(val) {
        this.logType = val;
      }
    }
  },
  methods: {


    /**
     * 处理下拉菜单点击事件
     * @param {string} command - 对应 el-dropdown-item 的 command 属性
     */
    handleImportCommand(command) {
      if (command === 'downloadTemplate') {
        this.downloadTemplate();
      } else if (command === 'uploadFile') {
        // 如果当前没有正在加载，才触发选择文件
        if (!this.importLoading) {
          this.triggerExcelImport();
        }
      }
    },

    /**
     * 下载模板逻辑
     */
    downloadTemplate() {

    let url='https://life-oasis.oss-cn-beijing.aliyuncs.com/template/2026%20%E7%97%9B%E7%BB%8F%E6%97%A0%E5%BF%A7%E6%A1%88%E4%BE%8B%E4%BA%A4%E6%B5%81%E9%A1%B9%E7%9B%AE%E6%A1%88%E4%BE%8B%E6%A8%A1%E6%9D%BF.xlsx'
      window.open(url)

      this.$notify({
        title: '正在下载',
        message: '模板文件下载已启动',
        type: 'success',
        position: 'bottom-right'
      });
    },

    // 1. 触发隐藏的文件选择框
    triggerExcelImport() {
      this.$refs.excelInput.click();
    },



    /**
     * 处理文件选择变化
     */
    async handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      // 简单校验后缀
      const fileName = file.name.toLowerCase();
      if (!fileName.endsWith('.xlsx') && !fileName.endsWith('.xls')) {
        this.$message.warning('请选择 .xlsx 或 .xls 格式的 Excel 文件');
        event.target.value = ''; // 清空以便重复选择
        return;
      }

      this.importLoading = true;

      try {
        // 2. 调用封装好的 API
        const response = await uploadCaseExcel(file);

        // 假设你的 request 拦截器已经处理了 code != 200 的情况，直接拿到 data
        // 如果后端返回结构是 { code: 200, data: { ... } }
        const parsedData = response.data;

        if (parsedData) {
          this.fillFormData(parsedData);
          this.$message.success('Excel 解析成功，数据已自动填充，请核对！');
        } else {
          this.$message.error('解析返回数据为空');
        }

      } catch (error) {
        console.error('Upload error:', error);
        // 这里可以根据 error 对象提取后端返回的错误信息
        this.$message.error(error.message || '导入失败，请检查文件格式');
      } finally {
        this.importLoading = false;
        event.target.value = ''; // 清空 input，允许重复上传同一文件
      }
    },

    /**
     * 核心逻辑：将解析后的数据填充到 editData 中
     * @param {Object} backendData - 后端返回的 JSON 对象
     */
    fillFormData(backendData) {
      console.log( this.editData)
      // 策略 A: 如果后端 Key 和 前端 Field 完全一致
      // 直接合并对象
      // this.editData = { ...this.editData, ...backendData };

      // 策略 B (推荐): 存在映射关系
      const newData = { ...this.editData };

      for (const key in backendData) {
        if (Object.prototype.hasOwnProperty.call(backendData, key)) {
          const value = backendData[key];


          // 检查是否有自定义映射
          const targetField = this.fieldMap[key] || key;

          // 只有当值不为空时才覆盖，或者根据需求强制覆盖
          if (value !== null && value !== undefined) {
            // 特殊处理：如果是数组类型 (如 jfxtj)，确保它是数组
            if (key === 'jfxtj' && !Array.isArray(value)) {
              newData[targetField] = value ? [value] : [];
            } else {
              newData[targetField] = value;
              console.log(value)
            }
          }
        }
      }
      console.log(newData)
      this.editData = newData;


      // [重要] 通知 form-create 组件数据已更新
      // 某些版本的 form-create 需要手动调用 setValue 或 refresh
      this.$nextTick(() => {

        this.$refs.generateForm.setData(newData);


        // if (this.$refs.generateForm) {
        //   // 尝试调用 form-create 的 API 刷新值
        //   // 如果是 form-create 2.x 或 3.x，通常绑定 :value 会自动更新，
        //   // 但如果没反应，可以尝试：
        //   this.$refs.generateForm.setValue(newData);
        // }
      });
    },






    async  exportToPDF(){
      try {
      const pdfBlob = await this.$refs.generateForm.exportPDF();
      // 创建下载链接
      const url = window.URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = '病例材料.pdf'; // 自定义文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      this.$message.success('PDF 导出成功！');
    } catch (error) {
      console.error('PDF 导出失败:', error);
      this.$message.error('PDF 导出失败，请确保已开启阅读模式并填充数据');
    }

},

    openUploadDialog() {
      this.$refs.UploadMaterialDialog.open();
    },

    handleCanal(){
      this.contributeDialog= false
    },



    reWrite(){
      // 1. 二次确认，防止误触
      this.$confirm('确定要撤回该案例吗？撤回后将恢复为【草稿】状态，您可以重新编辑并提交。', '提示', {
        confirmButtonText: '确定撤回',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 2. 调用后端撤回接口
        // 假设你的撤回接口是 PUT 或 POST，需要传入案例ID (inpId)
        withdrawInpsurvey( {
          inpId: this.surveyInfo.inpId // 确保当前组件有这个 ID，或者从 props/router 获取
        }).then(res => {
          if (res.code === 200) {
            this.$message.success('撤回成功，已恢复为草稿模式');
            this.loadCase()
          } else {
            this.$message.error(res.msg || '撤回失败');
          }
        }).catch(err => {
          if (err !== 'cancel') {
            console.error(err);
            this.$message.error('操作失败，请稍后重试');
          }
        });
      })


    },

    handleSave(){
      this.$refs.generateForm.getData(false).then(data => {
        submitInpsurvey({
          surId: this.surveyInfo.surId,
          answers: JSON.stringify(data),
          type:"save",
        }).then(res => {
          if (res.code == 200) {
            this.$notify({
              title: '提示',
              message: `案例保存成功`,
              type: 'success',
              position: 'bottom-right'
            });
            this.loadCase()
          } else {
            let  message = res.msg || '保存失败，请重试！';
            this.$message.error(message);
          }
        })
      })

    },

    handleSubmit(validate = true) {
      // 1. 第一步：先进行表单基础验证（必填项、格式等）
      this.$refs.generateForm.getData(validate).then(data => {

        // 2. 第二步：验证通过后，弹出带声明的确认框
        this.$confirm(
            `
      <div style="text-align: left; line-height: 1.6;">
        <div style="font-weight: bold; font-size: 16px; margin-bottom: 8px; color: #303133;">
          确认将案例提交到后台审核吗？
        </div>
        <div style="font-size: 13px; color: #606266; background: #f4f4f5; padding: 10px; border-radius: 4px; border-left: 4px solid #E6A23C;">
          <strong>声明：</strong><br/>
          本人确认本案例内容真实，已进行匿名化处理，并同意主办方及公益合作方（北京天安公益基金会）在学术交流与公益项目中匿名使用。
        </div>
      </div>
      `,
            '提交确认',
            {
              dangerouslyUseHTMLString: true, // ⚠️ 必须开启，允许渲染 HTML
              confirmButtonText: '确定提交',
              cancelButtonText: '再检查一下',
              type: 'warning',
              distinguishCancelAndClose: true, // 区分取消和关闭
              customClass: 'case-submit-confirm'
            }
        ).then(() => {
          // 3. 第三步：用户点击“确定提交”后，执行实际提交接口
          submitInpsurvey({
            surId: this.surveyInfo.surId,
            answers: JSON.stringify(data),
            type: "submit",
          }).then(res => {
            if (res.code == 200) {
              this.$notify({
                title: '成功',
                message: '案例已成功提交，等待审核',
                type: 'success',
                position: 'bottom-right',
                duration: 3000
              });

              this.contributeDialog = false;
              this.loadCase(); // 刷新列表
            } else {
              let message = res.msg || '提交失败，请重试！';
              this.$message.error(message);
            }
          }).catch(err => {
            // 接口请求失败的捕获
            console.error(err);
            this.$message.error('网络异常，提交失败');
          });

        }).catch((action) => {
          // 4. 第四步：用户点击“再检查一下”或关闭弹窗的处理
          if (action === 'cancel') {
            this.$message({
              type: 'info',
              message: '已取消提交，您可以继续完善案例'
            });
          }
        });

      }).catch(err => {
        // 5. 第五步：表单基础验证失败的处理（这一步在弹窗之前）
        this.$message.error("部分表单必填项尚未填写或格式不正确，请检查后提交");
      });
    },


    // 首页项目介绍
    getProjectFun() {
      getProject().then(res => {
        if (res.code == 200) {
          // console.log()
          this.mainColor = res.data.mainColor;
        }
      })
    },

    queryProject() {
      ProjectPage().then(res => {
        if (res.code == 200) {
          console.log("自定义表单", res.data.projectDocumentForm)
          this.projectInfo = res.data;
          this.formConfig = (JSON.parse(res.data.projectDocumentForm))

        }
      }).catch(err => {
        console.log(err)
      })
    },

    confirmCenterDialogVisible() {
      this.centerDialogVisible = false;
      const projectId = localStorage.getItem('projectId');
      // 设置过期时间为1小时后
      var expiration = new Date().getTime() + (1 * 60 * 60 * 1000);
      localStorage.setItem('tip' + projectId, JSON.stringify({
        value: 'example',
        expiration: expiration
      }));

    },
    getWithExpiration() {
      const projectId = localStorage.getItem('projectId');
      if (!projectId) {
        this.centerDialogVisible = true;
        return;
      }
      const cacheKey = 'tip' + projectId;
      const cachedTipStr = localStorage.getItem(cacheKey);

      if (!cachedTipStr) {
        this.centerDialogVisible = true;
        return;
      }

      try {
        const cachedTip = JSON.parse(cachedTipStr);
        const currentTime = new Date().getTime();

        if (currentTime > cachedTip.expiration) {
          console.log("数据已过期");
          localStorage.removeItem(cacheKey);
          this.centerDialogVisible = true;
        } else {
          console.log("数据未过期");
          this.centerDialogVisible = false;
        }
      } catch (error) {
        console.error("解析缓存数据失败", error);
        localStorage.removeItem(cacheKey); // 清除无效缓存
        this.centerDialogVisible = true;
      }
    },

    // 手动暂停视频的播放
    pause() {
      // 视频播放器的方法调用，要使用this.$refs.videoPlayer.player这个对象去调用
      this.$refs.videoPlayer.player.pause()
    },


    loginDialogFun(item) {
      this.logType = item;
      this.$store.state.logType = item
      this.loginDialog = true;
    },

    // // 下载模版、邀请函
    // download(link) {
    //   window.open(`${this.baseUrl}${link}`)
    //
    //   // <dl @click="download(`/article/template/downloadTemplate`)">
    //   // <dl @click="download(`/article/template/downloadInvitation`)">
    // },

    // 下载模版、邀请函
    // download(link) {
    //   fetch(`${this.baseUrl}${link}`, { // 替换为实际接口路径
    //     method: 'GET',
    //     headers: {
    //       // 若需要认证，需携带 Token
    //       'Project-Id': localStorage.getItem('projectId')
    //     }
    //   })
    //       .then(response => {
    //         if (!response.ok) throw new Error('下载失败');
    //         return response.blob(); // 将响应转为 Blob 对象
    //       })
    //       .then(blob => {
    //         const url = window.URL.createObjectURL(blob);
    //         const a = document.createElement('a');
    //         a.href = url;
    //         a.download = 'template.zip'; // 与后端 Content-Disposition 中的文件名一致
    //         a.style.display = 'none';
    //         document.body.appendChild(a);
    //         a.click();
    //         document.body.removeChild(a);
    //         window.URL.revokeObjectURL(url); // 释放内存
    //       })
    //       .catch(error => {
    //         console.error('下载错误:', error);
    //         alert('文件下载失败，请重试');
    //       });
    // },
    download(link) {
      let filename = 'template.zip'
      fetch(`${this.baseUrl}${link}`, { // 替换为实际接口路径
        method: 'GET',
        headers: {
          // 若需要认证，需携带 Token
          'Project-Id': localStorage.getItem('projectId')
        }
      }).then(response => {
        if (!response.ok) throw new Error('下载失败');

        console.log(response)


        // 从响应头中解析文件名（兼容编码格式）
        const contentDisposition = response.headers.get('Content-Disposition');
        console.log("contentDisposition", contentDisposition)
        if (contentDisposition) {
          const filenameRegex = /filename\*?=["']?(?:UTF-\d['"]*)?([^;\n"]*)["']?;?/i;
          const matches = filenameRegex.exec(contentDisposition);
          if (matches && matches[1]) {
            filename = decodeURIComponent(matches[1]); // 处理URL编码字符（如空格转%20）
          }
        }

        return response.blob(); // 将响应转为 Blob 对象
      }).then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename; // 与后端 Content-Disposition 中的文件名一致
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url); // 释放内存
      })
          .catch(error => {
            console.error('下载错误:', error);
            alert('文件下载失败，请重试');
          });

      this.$notify({
        title: '提示',
        message: `正在下载,请稍等`,
        type: 'success',
        position: 'bottom-right'
      });

    },
    // 快捷操作
    options() {
      let query = this.$route.query.opt;
      if (query == 'register') {
        this.loginDialogFun('注册');
      } else if (query == 'contribute') {
        setTimeout(() => {
          this.contributeDialogCk();
        }, 300)
      }
    },



    // 完善信息
    registerDialogCk() {
      if (this.userInfo) {
        this.registerDialog = true;
      } else {
        this.$confirm('您还未登录，是否现在登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          this.loginDialog = true;
          this.$store.state.logType = '登录';
          this.logType = '登录'
        })
      }
    },

    // 立即投稿
    contributeDialogCk() {
      console.log(this.userInfo.certificatesStatus)

      if (!this.userInfo) {
        this.$confirm('您还未登录，是否现在登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          this.loginDialog = true;
          this.$store.state.logType = '登录';
          this.logType = '登录'
        })
      } else if (this.userInfo.certificatesStatus == 'WAIT') {
        this.$confirm('您的四证资料正在审核中，请耐心等待。审核通过后，方可填写案例。', '温馨提示', {
          confirmButtonText: '我知道了',
          showCancelButton: false, // 审核中无需取消或操作，仅提示
          type: 'info'
        }).then(() => {
          // 可选：关闭弹窗后不执行任何操作
        });
      }else if (this.userInfo.certificatesStatus == 'ERROR') {
        this.$confirm(`您的四证信息被驳回，驳回理由：【${this.userInfo.certificatesMessage}】，请重新上传并确认。`, '提示', {
          confirmButtonText: '重新上传',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          this.registerDialog = true;
        })

      } else if (this.userInfo.certificatesStatus == 'NULL') {
        this.$confirm('您需要填写基础个人信息并完善备案信息后才能参与活动，是否现在去完善信息?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          this.registerDialog = true;
        })

      }else if (!this.userInfo.fullName || !this.userInfo.bankNumber || !this.userInfo.cardId) {
        this.$confirm('您需要填写基础个人信息并完善备案信息后才能参与活动，是否现在去完善信息?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          this.registerDialog = true;
        })
      }
      // else if ( this.userInfo.certificatesStatus != 'SUCCESS') {
      //   this.$confirm('您的个人信息正在审核中，请稍后再试。', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'info'
      //   })
      // }
      else {
        this.contributeDialog = true;
      }
    },

    // 获取我的投稿记录
    getMyDocument() {
      let data = {
        current: this.pageNum,
        size: this.pageSize,
      };
      myDocument(data).then(res => {
        if (res.code == 200) {
          this.total = res.data.total;
          console.log("文档：", res.data.records);
          this.tableData = res.data.records.map(record => {
            try {
              const formData = JSON.parse(record.documentFormData);
              return {
                ...record,
                ...formData
              };
            } catch (e) {
              console.error('JSON 解析失败:', record.documentFormData);
              return record;
            }
          });
          console.log("tableData", this.tableData);
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 获取用户投稿信息
    getMyStatistics() {
      myStatistics().then(res => {
        if (res.code == 200) {
          this.Statistics = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },

    getTips() {
      getTips().then(res => {
        if (res.code == 200) {
          this.tipList = res.data;
          if (this.tipList.length != 0) {
            this.getWithExpiration()

          }
        }
      })
    },
    //查询项目的案例
    loadCase(){
      getCase().then(res => {
        if (res.code == 200) {
          this.surveyInfo = res.data;
          this.jsonData = JSON.parse(res.data.surTemplate);
          console.log(this.jsonData)
          if (res.data.inpEntContent) {
            this.editData = JSON.parse(res.data.inpEntContent)
          }
          if(res.data.inpId){
            this.tableData=[]
            this.tableData.push(res.data)
          }
        }else {
          this.$message.error(res.msg);
        }
      })
    },


    // 获取用户信息
    getUserFun() {
      getUser().then(res => {
        if (res.code == 200) {
          this.userInfo = res.data;
          this.$forceUpdate()
        } else {}
      })
    },
    // getUserFun2() {
    // 	getUser().then(res => {
    // 		if (res.code == 200) {
    // 			this.userInfo = res.data;
    // 			if (!this.userInfo.cardId || !this.userInfo.fullName) {
    // 				this.$confirm('您需要完善个人资料后才可以进行投稿，现在否去完善资料？', '提示', {
    // 					confirmButtonText: '去完善资料',
    // 					type: 'info'
    // 				}).then(() => {
    // 					this.registerDialog = true;
    // 				}).catch(err => {
    // 					console.log(err)
    // 				})
    // 			}
    // 		}
    // 	})
    // },

    isMyAccount(flag) {
      // location.reload();
      let data = this.registeData
      if (flag) {
        // 是我的账号
        coverUser(data).then(res => {
          if (res.code == 200) {
            this.olduserShow = false;
            localStorage.setItem(
                'headToken', res.data
            )
            this.$notify({
              title: `${type}成功`,
              message: `${type}成功`,
              type: 'success',
              position: 'bottom-right'
            });
            location.reload();
          } else {
            this.$notify({
              title: `${type}失败`,
              message: `${res.msg}`,
              type: 'error',
              position: 'bottom-right'
            });
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        // 不是我的账号
        data.userName = data.userName + "B"
        regist(data).then(res => {
          if (res.code == 200) {
            this.olduserShow = false;
            localStorage.setItem(
                'headToken', res.data
            )
            this.$notify({
              title: `${type}成功`,
              message: `${type}成功`,
              type: 'success',
              position: 'bottom-right'
            });
            location.reload();
          } else {
            this.$notify({
              title: `${type}失败`,
              message: `${res.msg}`,
              type: 'error',
              position: 'bottom-right'
            });
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },

    // 登录成功后
    loginSuccessFun(e) {
      if (e.type) {
        this.loginDialog = false;
        this.getUserFun();
        this.getMyStatistics();
        this.getMyDocument();
        this.getTips();

        this.getUserFun();
        this.getMyStatistics();
        this.loadCase();


      }
      if (e.oldUser) {
        this.olduserShow = true;
        this.oldUser = e.oldUser
        this.registeData = e.registeData

        console.log(this.oldUser, "···············································")
      }
    },

    // 去注册
    toRegister(e) {
      if (e.type) {
        this.loginDialog = false;
        this.registerDialog = true;
      }
    },

    // 切换项目
    switchItems() {
      this.$confirm('是否确认切换项目?', '确认', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        // localStorage.clear();
        // this.$router.go(0);
        // window.location.reload();
        this.$router.push({
          name: 'switchItems'
        })

      })
    },

    // 退出登录
    logOut() {
      this.$confirm('是否确认退出登录?', '确认', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.getUserFun();
        this.getMyStatistics();
        this.getMyDocument();
        //项目id与项目名称不要清除
        const projectId = localStorage.getItem('projectId');
        const projectName = localStorage.getItem('projectName');
        localStorage.clear();
        localStorage.setItem('projectName', projectName);
        localStorage.setItem('projectId', projectId);

        this.tableData = [];
        this.userInfo = '';
        this.$notify({
          title: '退出成功',
          message: `退出成功`,
          type: 'success',
          position: 'bottom-right'
        });
        this.$router.go(0);
        // window.location.reload();
      })
    },

    // 投稿成功后子组件传值
    uploadSuccessFun(e) {
      if (e.type) {
        this.contributeDialog = false;
        this.getMyStatistics();
        this.getMyDocument();
      }
    },

    // 注册成功后子组件传值
    registerSuccessFun(e) {
      if (e.type) {
        this.registerDialog = false;
      }
      this.getUserFun();
    },



    //去签署合同
    signContract() {
      if(  this.loadingsign ==true){
        return;
      }

      if (!this.userInfo) {
        this.$confirm('您还未登录，是否现在登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          this.loginDialog = true;
          this.$store.state.logType = '登录';
          this.logType = '登录'
        })
        return;
      }


      this.loadingsign = true;
      signAgreement({
        inpId: 1
      }).then(res => {
        if (res.code == 200) {
          console.log("fanhui", res.data);
          window.open(res.data)
          this.loadingsign = false;
        } else {
          this.$notify({
            title: '签署失败',
            message: `${res.msg}`,
            type: 'error',
            position: 'bottom-right'
          });
          this.loadingsign = false;
        }
      }).catch(err => {
        this.loadingsign = false;
      }).finally(er=>{
        this.loadingsign=false
      })

    },


    handleCurrentChange(val) {
      this.pageNum = val
      this.getMyDocument();
    },
    // 首页获取logo banner 流程图
    getConfigFun() {
      getConfig().then(res => {
        if (res.code == 200) {
          this.banner = res.data.bannerPath;
        }
      })
    },


    // 格式化多选框值
    formatCheckboxValue(value, field) {
      if (!value || !Array.isArray(value)) return '-'

      // 匹配选项标签
      return value.map(v => {
        const option = field.options.find(opt => opt.label === v)
        return option ? option.label : v
      }).join(', ')
    },

    // 格式化单选框值
    formatRadioValue(value, field) {
      if (!value) return '-'
      const option = field.options.find(opt => opt.label === value)
      return option ? option.label : value
    }
  }
}
</script>

<style lang="scss" scoped>
$main-color: v-bind(mainColor); // 注意这里的写法在某些构建工具中可能不支持，需要使用其他方法

#UserCenter {
  .reasonText {
    margin: 7px 0;
  }


  ::v-deep .el-dialog {
    border-radius: 10px;

    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      padding: 50px 20px;
    }

    .top {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      p {
        font-size: 36px;
        color: rgba(31, 32, 34, 1);
      }

      b {
        font-size: 18px;
        color: $main-color;
      }
    }
  }


  ::v-deep .oldUser {
    .el-dialog {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      max-height: 90vh;
      overflow: hidden;
      margin: 0 !important;
    }

    .el-dialog__body {
      overflow: hidden;
      padding: 0;

      img {
        display: block;
        width: 100%;
      }
    }

    .UserBody {
      padding: 20px;

      .el-row {
        margin-top: 20px;
      }

      .el-col {
        margin-bottom: 20px;
        display: flex;
        font-size: 15px;
        align-items: center;

        &:last-child {
          margin-bottom: 0;
        }

        span {
          width: 100px;
          text-align: right;
          color: #112950;
          font-size: 14px;
        }

        b {
          padding: 8px 20px;
          border: 1px solid #ccc;
          flex: 1;
          border-radius: 8px;
          font-weight: normal;
          color: #000;
          height: 42px;
        }
      }
    }

    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .el-button {
        width: 45%;
      }
    }

  }

  ::v-deep .docView {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;

    .el-dialog {
      margin: 0 !important;
      width: 1200px;
      height: 90vh;

      .el-dialog__body {
        height: 100%;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;

        iframe {
          width: 100%;
          height: 100%;
          border: none;
        }

        .video-player {
          flex: 1;
        }

        .vjs-big-play-button {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }

  .banner {
    height: 630px;
    position: relative;
    width: 1200px;
    border-radius: 30px;
    overflow: hidden;
    margin: 20px auto 40px;

    .frame {
      display: none;
      position: absolute;
      height: 140%;
      right: -40px;
      top: 50%;
      transform: translateY(-50%);
    }

    .webHander {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      z-index: 1;
    }

    .background {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 0;
    }

    .mask {
      display: none;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 0;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(252, 253, 255, 1) 100%)
    }

    .main {
      position: absolute;
      width: 1000px;
      top: 0;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;

      .ban {
        height: 100px;
        margin-left: -30px;
        margin-bottom: 100px;
      }

      .cont {
        display: flex;
        flex-direction: column;

        p {
          font-size: 70px;
          font-weight: 600;
          line-height: 1.5;
          color: aliceblue;
          color: #0082CE;
        }

        b {
          font-size: 16px;
          font-weight: normal;
          margin-top: 12px;
          color: #666;
          opacity: .8;
          line-height: 1.5;

          img {
            height: 36px;
          }
        }
      }
    }
  }

  .user {
    width: 1200px;
    margin: 25px auto 0;
    border-bottom: 2px solid rgba(229, 229, 229, .6);
    border-top: 2px solid rgba(229, 229, 229, .6);
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding: 20px 0;

    .el-divider {
      height: 100px;
      width: 2px;
    }

    .el-avatar {
      width: 106px;
      height: 106px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 50px;
    }

    .el-button {
      width: 150px;
      height: 50px;
      border-radius: 8px;
      background: rgba(203, 50, 44, 0);
      border: 1px dashed $main-color;
      transition: all .3s;
      font-size: 16px;
      padding: 0;
      margin: 5px 0;

      &:hover {
        color: $main-color;
        border: 1px solid $main-color;
      }
    }

    div {
      display: flex;
      flex-direction: column;

      p {
        font-size: 60px;
        color: $main-color;
        text-align: center;
      }

      b {
        font-size: 28px;
        color: #333;
        font-weight: normal;
        text-align: center;
      }
    }
  }

  .part3 {
    padding: 100px 0 0;

    .tit {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 60px;

      p {
        font-size: 36px;
        text-align: center;
        color: rgba(31, 32, 34, 1);
      }

      b {
        font-size: 18px;
        text-align: center;
        color: $main-color;
      }
    }

    .cont {
      width: 1200px;
      margin: auto;
      display: flex;
      flex-direction: row;
      justify-content: space-around;

      dl {
        display: flex;
        flex-direction: column;
        justify-content: center;
        cursor: pointer;

        * {
          cursor: pointer;
        }

        dt {
          font-size: 40px;
          width: 160px;
          height: 160px;
          border-radius: 40px;
          border: 2px solid #f4f4f4;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.08);

          img {
            width: 100px;
            height: 100px;
          }

        }

        dd {
          font-size: 28px;
          color: rgba(0, 0, 0, 1);
          text-align: center;
          margin-top: 10px;
        }
      }
    }
  }

  .part2 {
    padding: 100px 0 0;

    .tit {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 60px;

      p {
        font-size: 36px;
        text-align: center;
        color: rgba(31, 32, 34, 1);
      }

      b {
        font-size: 18px;
        text-align: center;
        color: $main-color;
      }
    }

    .cont {
      width: 1200px;
      margin: auto;
      padding: 40px 35px;
      box-shadow: 2px 5px 10px rgba(0, 0, 0, 0.05);

      ::v-deep .el-tabs {

        .el-tabs__item {
          font-size: 20px;

          &:hover {
            color: rgba(203, 50, 44, .8);
          }
        }

        .el-tabs__item.is-active {
          color: $main-color;
        }

        .el-tabs__active-bar {
          background-color: $main-color;
        }
      }

      .el-pagination {
        text-align: center;
        margin-top: 20px;
      }

      .document,
      .video,
      .comic {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;

        dl {
          width: 31%;
          margin-bottom: 30px;


          dt {
            .el-image {
              width: 100%;
              height: 180px;
              border-radius: 4px;
            }
          }

          dd {
            font-size: 14px;
            color: rgba(102, 102, 102, 1);
            margin-top: 18px;
          }
        }
      }
    }
  }
}

.checked {

  .el-form-item__content {

    display: flex;
    justify-content: center;
    align-items: center;

    a {
      margin-left: 6px;
      text-decoration: underline;
      line-height: 1.5;
    }
  }

  .el-form-item__error {
    width: 100%;
    text-align: center;
  }
}



.contribute-dialog .el-dialog__body {
  padding: 0 !important; /* 清除默认 padding */
}

.contribute-dialog .dialog-body {
  display: flex;
  flex-direction: column;
  max-height: 80vh; /* 限制整体高度 */
}

.contribute-dialog .dialog-content {
  flex: 1;
  overflow-y: auto;
  padding: 0 20px;
}

.contribute-dialog .dialog-footer {
  padding: 20px;
  text-align: right;
}



.my-custom-form {
  ::v-deep .el-textarea__inner {
    min-height: 100px !important; /* 强制设置最小高度为 100px */
    height: auto; /* 确保高度可以随内容自动撑开，而不是固定死 */
    line-height: 1.5; /* 可选：优化行高，让文字看起来更舒服 */
  }

  /* 3. 针对分隔符内部的文本 span (有时文字是在 span 里的) */
  ::v-deep .fm-divider span,
  ::v-deep .el-divider__text,
  ::v-deep .fm-title span {
    white-space: nowrap !important; /* 【关键】再次确保内部文字不换行 */
    display: inline-block;
    width: auto !important;
    padding: 0 10px; /* 可选：给文字两边加点padding，美观一点 */
  }


}

</style>
